import { QueryClient } from '@tanstack/react-query';

export const QUERY_CACHE_MAX_AGE = 14 * 24 * 60 * 60_000;

let activeUserId: string | null = null;

export function activateQueryCacheForUser(
  userId: string
): void {
  if (activeUserId && activeUserId !== userId) {
    queryClient.clear();
  }
  activeUserId = userId;
}

export function clearActiveQueryCache(): void {
  activeUserId = null;
  queryClient.clear();
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60_000,
      gcTime: QUERY_CACHE_MAX_AGE,
      retry: 1,
    },
  },
});

queryClient.setQueryDefaults(['me'], {
  staleTime: 10 * 60_000,
});
queryClient.setQueryDefaults(['calendars'], {
  staleTime: 10 * 60_000,
});
queryClient.setQueryDefaults(['billing'], {
  staleTime: 10 * 60_000,
});
queryClient.setQueryDefaults(['members'], {
  staleTime: 10 * 60_000,
});
queryClient.setQueryDefaults(['events'], {
  staleTime: 60_000,
  refetchOnWindowFocus: true,
  refetchOnMount: true,
});
